module.exports = __webpack_public_path__ + "img/e8.7c222f3f.jpg";